var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelCorporateInstallationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.14 6.43h-6.878a2 2 0 0 0-2 2v6.876a2 2 0 0 0 2 2h6.879a2 2 0 0 0 2-2V8.43a2 2 0 0 0-2-2zM15.438 6.43H8.56a2 2 0 0 0-2 2v6.876a2 2 0 0 0 2 2h6.878a2 2 0 0 0 2-2V8.43a2 2 0 0 0-2-2zM15.438 21.39H8.56a2 2 0 0 0-2 2v6.877a2 2 0 0 0 2 2h6.878a2 2 0 0 0 2-2v-6.876a2 2 0 0 0-2-2z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u8ajkzjwma)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.943 24.912v4.33m-2.166-2.165h4.332m3.248 0a5.414 5.414 0 1 1-10.827 0 5.414 5.414 0 0 1 10.827 0z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "u8ajkzjwma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20.446 20.578)",
    d: "M0 0h12.994v12.992H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelCorporateInstallationsIcon);
export default __webpack_public_path__ + "static/media/paltelCorporateInstallationsIcon.5734bd2a3f861b7f892d6fdf0b4b30b6.svg";
export { ForwardRef as ReactComponent };